import React, { useState } from 'react';
import { TableCell, TableRow, Icon, Button } from '@safedns/skydns-ui-react-lib';

import DeleteDomain from './RemoveDomain';
import EditDomain from './UpdateDomain';

import sprite from '../../icons/sprite.svg';
import { actionTableCellStyle } from '../../styles/tableStyles';

const DomainsListItem = ({ id, domain, groups, users }) => {
  const [isEditDialogShow, setEditDialogState] = useState(false);
  const [isDeleteDialogShow, setDeleteDialogState] = useState(false);

  const editDialogHandler = () => {
    setEditDialogState((prevState) => !prevState);
  };

  const deleteDialogHandler = () => {
    setDeleteDialogState((prevState) => !prevState);
  };

  return (
    <>
      <TableRow>
        <TableCell scope="row">{domain}</TableCell>
        <TableCell align="left">{groups}</TableCell>
        <TableCell align="left">{users}</TableCell>
        <TableCell align="center" sx={actionTableCellStyle}>
          <Button variant="icon" isIconButton onClick={editDialogHandler}>
            <Icon id="edit" sprite={sprite} width={22} height={22} />
          </Button>
        </TableCell>
        <TableCell align="center" sx={actionTableCellStyle}>
          <Button variant="icon" isIconButton onClick={deleteDialogHandler}>
            <Icon id="remove" sprite={sprite} width={22} height={22} />
          </Button>
        </TableCell>
      </TableRow>
      <DeleteDomain
        domainId={id}
        domainName={domain}
        isClosed={isDeleteDialogShow}
        onClose={deleteDialogHandler}
      />
      <EditDomain
        domainId={id}
        domainName={domain}
        isClosed={isEditDialogShow}
        onClose={editDialogHandler}
      />
    </>
  );
};

export default DomainsListItem;
